import { useState, useEffect } from "react";
import DeliveryManagement from "../userComponent/deliveryManagement"
import StoreManagement from "../userComponent/storeManagement"
import Breadcrumb from "../../../../component/breadcrumb"
import { Typography } from "@mui/material";
import { useSelector } from 'react-redux';
import ProgressBar from "../../../../component/progressBar"
import { useParams } from "react-router-dom";
import axiosInstance from '../../../../configuration/request';
import { useSnackbar } from '../../../../component/SnackbarContext';
import {
    mapPersonalDetails,
    mapOtherDetails,
    mapBankDetails,
    mapStoreDetails
} from "../../../../utils/mapUserData";

const BCrumb = [
    {
        to: '/app/user-management',
        title: 'User Management',
    },
    {
        title: 'Edit User',
    },
];

function EditUser() {
    const showSnackbar = useSnackbar();
    const { userType } = useSelector(state => state.counter);
    const [progressValue, setProgressValue] = useState(0);
    const { id } = useParams();
    const [userDetails, setUserDetails] = useState({
        personal: {},
        otherDetails: {},
        bankDetails: {},
        uploadDocs: {}
    });

    const progressHandler = (progress) => {
        setProgressValue(progress)
    }

    useEffect(() => {
        fetchUser();
    }, []);

    const fetchUser = async () => {
        try {
            const res = await axiosInstance.get(`/customer/users?id=${id}`);
            const data = res?.data?.data[0];
            const updatedDetails = {
                personal: mapPersonalDetails(data),
                bankDetails: mapBankDetails(data?.bankDetails?.[0]),
            };

            if (userType === "delivery user") {
                updatedDetails.otherDetails = mapOtherDetails(data?.deliveryPerson);
                  updatedDetails.uploadDocs = data?.deliveryPerson?.uploadDoc || []
            }

            if (userType === "business user" && data?.stores?.length > 0) {
                updatedDetails.storeDetails = mapStoreDetails(data?.stores[0]);
                updatedDetails.uploadDocs = data?.stores[0]?.uploadDoc || []
                updatedDetails.serviceDetails = data?.stores[0]?.services || [];
            }
            setUserDetails(updatedDetails);
        } catch (err) {
    
            showSnackbar("Failed to fetch user details", "error");
        } 
    };

    const updateUser = () => {
        fetchUser()
    }


    return (
        <div className="px-[24px]">
            <div className="flex justify-between mb-5 ml-6 mr-4">
                <Breadcrumb title="" items={BCrumb} />
                <div className="flex items-center gap-1 mr-[8px]"
                >
                    <Typography fontSize={14}>Profile Completion</Typography>
                    <ProgressBar progress={progressValue} />
                </div>
            </div>
            {userType === "delivery user" && (
                <DeliveryManagement handleProgress={progressHandler} user={"admin"} mode={"edit"} id={id} userDetails={userDetails} updateUser={updateUser} />
            )}
            {userType === "business user" && (
                <StoreManagement handleProgress={progressHandler} user={"admin"} mode={"edit"} id={id} userDetails={userDetails} updateUser={updateUser} />
            )}

        </div>

    );
}

export default EditUser;
